import React, { useState } from 'react';
import api from '../../api/axiosConfig';
import '../PasswordChangeModal/PasswordChangeModal.css';

const TwoFactorSetupModal = ({ onClose, onSuccess }) => {
  const [step, setStep] = useState('qr');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGenerarQR = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.post('/crearSecreto');
      setQrCodeUrl(response.data.qrCodeUrl);
    } catch (err) {
      setError('Error al generar el código QR');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await api.post('/verificarSecreto', { token: code });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Código inválido. Intentá de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  // Auto-generate QR on mount (lazy, when step is qr and no url yet)
  React.useEffect(() => {
    handleGenerarQR();
  }, []);

  return (
    <div className="pwd-overlay" onClick={onClose}>
      <div className="pwd-modal" onClick={e => e.stopPropagation()}>
        <div className="pwd-step-indicator">
          <div className="pwd-step-dot active"></div>
          <div className={`pwd-step-dot ${step === 'verify' ? 'active' : ''}`}></div>
        </div>

        {step === 'qr' && (
          <>
            <h3>Configurar doble factor</h3>
            <p>Escaneá este código QR con tu aplicación de autenticación (Google Authenticator, Authy, etc.)</p>

            {error && <div className="pwd-error">{error}</div>}

            {loading && !qrCodeUrl && (
              <p style={{ color: '#64748b', fontSize: '13px', marginBottom: '16px' }}>
                <i className="bi bi-hourglass-split" style={{ marginRight: 6 }}></i>Generando QR...
              </p>
            )}

            {qrCodeUrl && (
              <>
                <img
                  src={qrCodeUrl}
                  alt="QR Code"
                  style={{ width: '200px', height: '200px', borderRadius: '8px', border: '2px solid #e2e8f0', marginBottom: '20px' }}
                />
                <button
                  className="pwd-btn"
                  onClick={() => setStep('verify')}
                >
                  Ya escaneé el código
                </button>
              </>
            )}

            <button type="button" className="pwd-btn-outline" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
          </>
        )}

        {step === 'verify' && (
          <>
            <h3>Verificar código</h3>
            <p>Ingresá el código de 6 dígitos que muestra tu aplicación</p>

            {error && <div className="pwd-error">{error}</div>}

            <form onSubmit={handleVerify}>
              <input
                type="text"
                className="pwd-input-code"
                value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="000000"
                maxLength={6}
                autoFocus
                disabled={loading}
              />
              <button
                type="submit"
                className="pwd-btn"
                disabled={loading || code.length !== 6}
              >
                {loading ? 'Verificando...' : 'Activar doble factor'}
              </button>
              <button type="button" className="pwd-btn-outline" onClick={onClose} disabled={loading}>
                Cancelar
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default TwoFactorSetupModal;
